import { Culture } from "@kolibrisoftware/customerportal-api";

const cultureToLocaleMap: Record<Culture, string> = {
  [Culture.Nl]: "nl-NL",
  [Culture.En]: "en-US",
};

export const getLocaleFromCulture = (culture: Culture): string =>
  cultureToLocaleMap[culture] || "nl-NL";
